import { Component, OnDestroy, OnInit, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { OidPenPackagesService } from '../../../../../../services/oid-pen-packages.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Editor, Toolbar } from 'ngx-editor';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {Decoration, DecorationSet} from 'prosemirror-view';
import { EditorState, Plugin, PluginKey, Transaction } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { isNodeActive } from 'ngx-editor/helpers';
import { setBlockType } from 'prosemirror-commands';
import { HWResourceService as ResourceService, HWResourceService } from '../../../../../../services/huawei-resource.service';
import { buildCopiedObjectLocation, md5To6 } from './oid-pen-package-file.util';


@Component({
    selector: 'app-oid-pen-packages',
    templateUrl: './oid-pen-packages.component.html',
    styleUrls: ['./oid-pen-packages.component.scss'],
    standalone: false
})
export class OidPenPackagesComponent implements OnInit, OnDestroy {
  loading = false;
  items: any[] = [];
  total = 0;
  pageSize = 10;
  pageIndex = 1;
  imageUploadProgress = 0;
  packageUploadProgress = 0;
  packageUploading = false;
  // Filters
  searchKeyword = '';
  selectedSyllabusId: number | null = null;
  syllabusList: any[] = [];
  // Form related
  modalVisible = false;
  modalTitle = '发布点读包';
  editId: number | null = null;

  validateForm: FormGroup;
  showBookSelectDialog = false;
  _bookSelection: any = new Map<string, number>();
  relBookName: string | null = null;
  relBookCover: string | null = null;
  set bookSelection (value: any) {
    const {id, name, cover} = value.get(0);
    this.relBookName = name;
    this.relBookCover = cover;
    this.validateForm.patchValue({bookId: id});
    this.showBookSelectDialog = false;
  }
  get bookSelection () {
    return this._bookSelection;
  }
  // Tags selection
  availableTags: any[] = [];

  constructor(
    private oidPenPackagesSvc: OidPenPackagesService,
    private message: NzMessageService,
    private modal: NzModalService,
    private resService: ResourceService,
    private cdr: ChangeDetectorRef
  ) {

    this.validateForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      syllabusId: new FormControl(0),
      summary: new FormControl(''),
      cover: new FormControl(''),
      size: new FormControl(0),
      version: new FormControl(''),
      // status: new FormControl(1),
      bookId: new FormControl(0),
      tagIds: new FormControl([]),
      newTagNames: new FormControl([]),
      url: new FormControl(''),
      coverOid: new FormControl(0, [Validators.required]),
      pageOidStart: new FormControl(0, [Validators.required]),
      pageOidEnd: new FormControl(0, [Validators.required]),
      seq: new FormControl(0),
    });
  }

  ngOnInit(): void {

    // @ts-ignore
    // this.editor.registerPlugin(this.placeholderPlugin);
    this.loadSyllabus();
    this.loadTags();
    this.loadItems();
  }

  ngOnDestroy(): void {
  }

  loadSyllabus(): void {
    this.oidPenPackagesSvc.getSyllabus().then(res => {
      this.syllabusList = this.extractListData(res);
    });
  }

  loadTags(): void {
    this.oidPenPackagesSvc.getTags().then(res => {
      this.availableTags = this.extractListData(res);
    });
  }

  private extractListData(res: any): any[] {
    if (!res) {
      return [];
    }
    if (Array.isArray(res)) {
      return res;
    }

    // Common response structures
    if (Array.isArray(res.data)) {
      return res.data;
    }
    if (Array.isArray(res.rows)) {
      return res.rows;
    }
    if (Array.isArray(res.list)) {
      return res.list;
    }

    // Nested structures like { data: { list: [] } } or { data: { rows: [] } }
    if (res.data) {
      if (Array.isArray(res.data.list)) {
        return res.data.list;
      }
      if (Array.isArray(res.data.rows)) {
        return res.data.rows;
      }
    }

    return [];
  }

  loadItems(): void {
    this.loading = true;
    const params = {
      page: this.pageIndex,
      limit: this.pageSize,
      keyword: this.searchKeyword,
    };
    if (this.selectedSyllabusId) {
      // @ts-ignore
      params.syllabusId = this.selectedSyllabusId || 0;
    }
    this.oidPenPackagesSvc.getPackages(params).then(res => {
      this.loading = false;
      // Handle both { list, total } and { data: { list, total } }
      const data = res.data || res;
      this.items = data.list || [];
      this.total = data.total || 0;
    }).catch(() => {
      this.loading = false;
      this.message.error('加载文章列表失败');
    });
  }

  onPageIndexChange(index: number): void {
    this.pageIndex = index;
    this.loadItems();
  }

  openAdd(): void {
    this.modalTitle = '发布点读包';
    this.editId = null;
    this.validateForm.reset({

      name: '',
      syllabusId: 0,
      summary: '',
      cover: '',
      version: '',
      size: 0,
      bookId: 0,
      tagIds: [],
      newTagNames: [],
      url: '',
      coverOid: 0,
      pageOidStart: 0,
      pageOidEnd: 0,
      seq: 0,
    });
    this.relBookName = null;
    this.relBookCover = null;
    this.packageUploading = false;
    this.packageUploadProgress = 0;
    this.modalVisible = true;
  }

  openEdit(id: number): void {
    this.modalTitle = '编辑点读包';
    this.editId = id;
    this.packageUploading = false;
    this.packageUploadProgress = 0;
    this.loading = true;
    this.oidPenPackagesSvc.getPackageDetail(id).then(res => {
      this.loading = false;
      const oidPack = res;
      this.validateForm.patchValue({
        name: oidPack.name,
        syllabusId: oidPack.syllabusId || 0,
        summary: oidPack.summary,
        cover: oidPack.cover,
        bookId: oidPack.bookId,
        version: oidPack.version || '',
        // status: oidPack.status,
        tagIds: oidPack.tags ? oidPack.tags.map((t: any) => t.id) : [],
        newTagNames: [],
        url: oidPack.url,
        coverOid: oidPack.coverOid,
        pageOidStart: oidPack.pageOidStart,
        pageOidEnd: oidPack.pageOidEnd,
        seq: oidPack.seq,
      });

      this.relBookName = oidPack.bookName;
      this.relBookCover = oidPack.bookCover;
      this.modalVisible = true;
    }).catch(() => {
      this.loading = false;
      this.message.error('获取文章详情失败');
    });
  }

  closeModal(): void {
    this.modalVisible = false;
  }

  onCoverUploaded(event: any): void {
    if (event && event.url) {
      this.validateForm.patchValue({ cover: event.url });
    }
  }

  savePackageInfo(): void {
    if (this.validateForm.invalid) {
      this.message.warning('请填写必填项');
      return;
    }

    const data = this.validateForm.value;
    if (!data.size) {
      delete data.size;
    }
    const parts = this.validateForm.controls['url'].value.split('/');
    const hash_part =  parts[parts.length - 1];
    if (hash_part.length >= 32) {
      const md5 = parts[parts.length - 1].substring(0, 32);
      if (/^[0-9a-f]{32}$/.test(md5)) {
        const version = md5To6(md5);
        data['version'] = version.toLowerCase();
        // this.validateForm.controls['version'].setValue(version.toLowerCase());
      } else {
        // delete this.validateForm.controls['version'];
        delete data['version']
      }
    }


    const saveAction = this.editId
      ? this.oidPenPackagesSvc.updatePackage(this.editId, data)
      : this.oidPenPackagesSvc.createPackage(data);



    const t1 = Date.now();
    this.loading = true;
    saveAction.then(async (resp) => {
      const packageUrl = resp?.url || data.url;

      if (packageUrl && resp?.id != null) {
        const { oldKey, newKey, newUrl } = buildCopiedObjectLocation({
          sourceUrl: packageUrl,
          bucket: this.resService.bucket,
          // fileName: `${data.coverOid}-${data.name}`,
          fileName: `${data.coverOid}`,
        });

        if (oldKey !== newKey) {
          await this.resService.copyObject({
            Key: newKey,
            CopySource: `${this.resService.bucket}/${oldKey}`,
          });
          await this.oidPenPackagesSvc.updatePackage(resp.id, {
            ...data,
            url: newUrl,
          });
        }
      }
      const now = Date.now();
      const delta = 1000 - (now - t1);
      setTimeout(() => {
        this.message.success(this.editId ? '更新成功' : '发布成功');
        this.modalVisible = false;
        if (!this.editId) {
          this.pageIndex = 1;
        }
        this.loadItems();
      }, delta);
    }).catch((err) => {
      if (typeof err.message === 'string' && err.message.includes('Duplicate entry')) {
        err.message = '已存在同本关联书籍，请检查';
      }
      this.message.error(err.message || '操作失败');
      this.loading = false;
    });
  }

  deleteArticle(id: number): void {
    this.modal.confirm({
      nzTitle: '确认删除该文章吗？',
      nzContent: '删除后将进入回收站。',
      nzOkText: '确认',
      nzOkDanger: true,
      nzOnOk: () => {
        this.loading = true;
        const t1 = Date.now();
        this.oidPenPackagesSvc.deletePackage(id).then(() => {
          const now = Date.now();
          const delta = 1000 - (now - t1);
          setTimeout(() => {
            this.loading = false;
            this.message.success('删除成功');
            this.loadItems();
          }, delta);
        }).catch(err => {
          this.message.error(err.message || '删除失败');
        });


      }
    });
  }

  getStatusText(status: number): string {
    switch (status) {
      case 0: return '草稿';
      case 1: return '已发布';
      case -1: return '已删除';
      default: return '未知';
    }
  }

  getStatusColor(status: number): string {
    switch (status) {
      case 0: return 'orange';
      case 1: return 'green';
      case -1: return 'red';
      default: return 'default';
    }
  }


  ///////////////////////////////////////////////////


  openSelectBookDialog() {
    this.showBookSelectDialog = true;
  }
  closeBookSelectDialog () {
    this.showBookSelectDialog = false;
  }
  bookSelected(row: any) {
    console.log(row);
  }

  updatePackageSize(size: number) {
    this.validateForm.controls['size'].setValue(size);
  }
  onPackageUploaded(evt: any) {
    this.packageUploading = false;
    this.packageUploadProgress = 100;
    this.validateForm.controls['url'].setValue(evt.url);

  }
  onPackageUploading(evt: any) {
    const progress = typeof evt?.progress === 'number' ? evt.progress : 0;
    this.packageUploading = true;
    this.packageUploadProgress = Math.floor(Math.min(Math.max(progress, 0), 1) * 100);
    this.cdr.detectChanges();
  }

  // onPackageUploading(evt: any) {
  //   console.log('onPackageUploading', evt);
  //   this.validateForm.controls['url'].setValue(evt.url);
  // }

  // uploadFile(file: File): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     this.hwSvc.asyncDoUpload({
  //       file: file as any,
  //       osspath: 'article/images',
  //       success_cb: (res: any) => {
  //         resolve(res.url);
  //       },
  //       error_cb: (err: any) => {
  //         this.message.error('图片上传失败');
  //         reject(err);
  //       }
  //     });
  //   });
  // }
  //


}
